import Layout from "../../components/layout/Layout";
import "./profile.css";

const Profile = () =>{
    return(
         <Layout>
            <></>
        </Layout>
    )
} 

export default Profile